module.exports = "/resources/assets/prod/4edcb4e9c443bfe92246a3468061a29b.jpg";